import { brandsUrl, prod } from "application/constants/app-constants";
import { getBrand } from ".";

export default function getExternalUrl() {
  if (!prod) {
    return "https://pre-microgtw-core.md.apps.axpreecocp2.ecommerce.inditex.grp";
  }
  return `https://www.zara.com/integration/book`;
}
